var map = {
	"./Air.svg": 1420,
	"./Earth.svg": 1421,
	"./Fire.svg": 1422,
	"./Water.svg": 1423
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 211;


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/elements ^\.\/.*\.svg$
// module id = 211
// module chunks = 0